import React, { useEffect, useRef, useState } from "react";
import './ItemsAndPresetModal.css';
import { MdCancel } from "react-icons/md";
import '../../Variable.css';
import { IoMdAdd } from "react-icons/io";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import CkDictionaryDs from "../../DataServices/CkDictionaryDs";


const ItemsAndPresetObjectsModal = ({ onClose, type, existingObject, isEditModeOn, getJsonFromModal }) => {
  // console.log(existingObject);
  const ckDictionaryDs = new CkDictionaryDs();

  const [jsonData, setJsonData] = useState();
  const [jsonError, setJsonError] = useState("");
  const [collectionName, setCollectionName] = useState('');
  const [collapsed, setCollapsed] = useState(true);
  const [display, setDisplay] = useState(existingObject.display || "show");
  const [subGroupCollectionName, setSubGroupCollectionName] = useState('');
  const [subGroupCollapsed, setSubGroupCollapsed] = useState(true);
  const [subGroupDisplay, setSubGroupDisplay] = useState("show");

  const [activeTab, setActiveTab] = useState("json");

  const [listData, setListData] = useState([]);
  const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
  const [isDirty, setIsDirty] = useState(false);

  const [subGroupCollectionError,setSubGroupCollectionError] = useState(false);
  const [subGroupCollectionErrorMsg, setSubGroupCollectionErrorMsg] = useState("");

  const [CollectionError,setCollectionError] = useState(false);
  const [CollectionErrorMsg, setCollectionErrorMsg] = useState("");
  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    if (!existingObject) return;

    if (type === 'SubGroup') {

      const subGroupName = existingObject.displayText || "";
      const subGroupCollapsedValue = existingObject.collapsed ?? true;
      const subGroupDisplayValue = existingObject.display || "show";
  
      setSubGroupCollectionName(subGroupName);
      setSubGroupCollapsed(subGroupCollapsedValue);
      setSubGroupDisplay(subGroupDisplayValue);
  
      setInitialData({
        collectionName: subGroupName,
        collapsed: subGroupCollapsedValue,
        display: subGroupDisplayValue
      });

    }

    else if (type === 'Item') {
      const itemCollectionName = existingObject.displayText || "";
      const itemCollapsedValue = existingObject.collapsed ?? true;
      const itemDisplayValue = existingObject.display || "show";
      const itemList = Array.isArray(existingObject.items)
        ? existingObject.items
        : [];

      setCollectionName(itemCollectionName);
      setCollapsed(itemCollapsedValue);
      setDisplay(itemDisplayValue);

      if (itemList.length > 0) {
        setJsonData(JSON.stringify(itemList, null, 2));
        setListData(itemList.map(i => ({ ...i, _isNew: false })));
      } else {
        setJsonData('');
        setListData([]);
      }

      // Initial Data
      setInitialData({
        collectionName: itemCollectionName,
        collapsed: itemCollapsedValue,
        display: itemDisplayValue,
        items: itemList
      });
    }

    else if (type === 'Preset') {
     const presetCollectionName = existingObject.displayText || "";
      const presetList = Array.isArray(existingObject.presets)
        ? existingObject.presets
        : [];

        setCollectionName(presetCollectionName);

      if (presetList.length > 0) {
        setJsonData(JSON.stringify(presetList, null, 2));
        setListData(presetList.map(p => ({ ...p, _isNew: false })));
      } else {
        setJsonData('');
        setListData([]);
      }

      setInitialData({
        collectionName: presetCollectionName,
        presets: presetList
      });
      
    }

    console.log("Existing Object:", existingObject);
    setIsDirty(false);
  }, [existingObject, type]);


  const handleCollectionNameChange = (e) => {
    const value = e.target.value;

    setCollectionName(value);
    setIsDirty(true);

    if (CollectionError) {
      setCollectionError(false);
      setCollectionErrorMsg("");
    }
  };

  const validateCollectionName = (value) => {
    const trimmed = value.trim();
  
    if (!trimmed) {
      return "Collection name is required";
    }
  
    if (!/[a-zA-Z0-9]/.test(trimmed)) {
      return "Only special characters are not allowed";
    }
  
    return "";
  };

  const handleSubGroupChange = (e) => {
    let value = e.target.value;

    setSubGroupCollectionName(value);
    setIsDirty(true);

    if (subGroupCollectionError) {
      setSubGroupCollectionError(false);
      setSubGroupCollectionErrorMsg("");
    }

  };


  const handleAddPreset = () => {
    setListData([{ preset_id: "", display_text: "", icon: "", _isNew: true }, ...listData]);
    setIsDirty(true);

  };

  const handleIconUpload = (index, file) => {
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml"
    ];

    if (!allowedTypes.includes(file.type)) {
      showToast({ message: "Only PNG, SVG, JPG, JPEG files are allowed" });
      return;
    }

    const maxSize = 50 * 1024;
    if (file.size > maxSize) {
      showToast({ message: "File size must be 50 KB or less!" });
      return;
    }

    convertFileToBase64(file, (base64) => {
      const updated = [...listData];
      updated[index].icon = {
        fileName: file.name,
        base64
      };
      setListData(updated);
      setIsDirty(true);

    });
  };

  const fileInputRefs = useRef([]);

  const handleClearIcon = (index) => {
    showAlert(
      "Are you sure you want to clear the uploaded icon ?",
      [
        {
          label: "No",
          color: "gray",
          onClick: () => { }
        },
        {
          label: "Yes",
          color: "var(--buttonColor)",
          onClick: () => {
            const updated = [...listData];

            updated[index].icon = "";

            setListData(updated);
            setIsDirty(true);

            // 🔥 IMPORTANT: reset input value
            if (fileInputRefs.current[index]) {
              fileInputRefs.current[index].value = "";
            }
          }
        }
      ]
    );
  };

  const handlePresetSave = async (index) => {
    try {
      const row = listData[index];

      if (!row.icon || !row.icon.base64) {
        showToast({ message: "Please upload an icon" });
        return;
      }

      hud("Please wait...");

      let payload;
      if (row._isNew) {
        payload = {
          ck_dictionary_id: existingObject.ck_dictionary_id,
          preset: {
            display_text: "",
            icon: {       
              fileName: row.icon.fileName,
              base64: row.icon.base64
            }
          }
        };
      } else {
        payload = {
          ck_dictionary_id: existingObject.ck_dictionary_id,
          itemlist_display_text: existingObject.displayText || collectionName,
          preset: {
            preset_id: row.preset_id,
            display_text: row.display_text,
            icon: {
              fileName: row.icon.fileName,
              base64: row.icon.base64
            }
          }
        };
      }

      console.log("PRESET PAYLOAD:", payload);

      const response = await ckDictionaryDs.WS_CK_Dictionary_Icon_Update(payload);
      const data = response?.data ?? response;

      const parsedBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200 || response?.status === 200) {
        const s3Key = parsedBody?.iconKey;
        const updatedList = [...listData];

        updatedList[index] = {
          ...updatedList[index],
          icon: s3Key,     
          _isNew: false    
        };

        setListData(updatedList);
        showToast({ message: "Preset icon uploaded successfully " });

      } else {
        console.log("Error :", parsedBody?.message || parsedBody?.error);
        showAlert("Failed to upload preset icon",
          [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
        );
      }

    } catch (error) {
      console.error("ERROR:", error);
      showAlert("Failed to upload preset icon", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
    }
    finally {
      stopHudRotation();
    }
  };


  const handleAddItem = () => {
    setListData(prev => [{ code: "", display_text: "", icon: "", long_description: "", short_description: "",log_text:"", display: "hide", preset_ids: [], _isNew: true }, ...prev]);
    setIsDirty(true);
  };

  const handleItemIconUpload = (index, file) => {
    if (!file) return;
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml"
    ];
    if (!allowedTypes.includes(file.type)) {
      showToast({ message: "Only PNG, SVG, JPG, JPEG files are allowed" });
      fileInputRefs.current[index].value = "";
      return;
    }
    if (file.size > 50 * 1024) {
      showToast({ message: "File size must be 50 KB or less." });
      fileInputRefs.current[index].value = "";
      return;
    }
    convertFileToBase64(file, (base64) => {
      const updated = [...listData];
      updated[index].icon = {
        fileName: file.name,
        base64
      };
      setListData(updated);
      setIsDirty(true);
    });
  };


  const handleItemSave = async (index) => {
    try {
      const row = listData[index];

      if (!row.icon || !row.icon.base64) {
        showToast({ message: "Please upload an icon" });
        return;
      }

      hud("Please wait..");
      
      let payload;

      if (row._isNew) {
        payload = {
          ck_dictionary_id: existingObject.ck_dictionary_id,
          item: {
            icon: {
              fileName: row.icon.fileName,
              base64: row.icon.base64
            }
          }
        };
      } else {
        payload = {
          ck_dictionary_id: existingObject.ck_dictionary_id,
          item_having_subgroup: existingObject.item_having_subgroup,
          itemlist_display_text: existingObject.displayText || collectionName,
          item: {
            code: row.code,
            display_text: row.display_text,
            icon: {
              fileName: row.icon.fileName,
              base64: row.icon.base64
            }
          }
        };

        if (existingObject.item_having_subgroup) {
          payload.subgroup_display_text = existingObject.subGroupName;
        }
      }

      console.log("ITEM PAYLOAD:", payload);

      const response = await ckDictionaryDs.WS_CK_Dictionary_Icon_Update(payload);
      const data = response?.data ?? response;

      const parsedBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200 || response?.status === 200) {
        const s3Key = parsedBody?.iconKey;
        const updatedList = [...listData];

        updatedList[index] = {
          ...updatedList[index],
          icon: s3Key,     
          _isNew: false    
        };
        setListData(updatedList);
        syncListToJson(updatedList);

        showToast({ message: "Item icon uploaded successfully" });
      } else {
        console.log("Error :", parsedBody?.message || parsedBody?.error);
        showAlert("Failed to upload item icon",
          [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
        );
      }

    } catch (error) {
      console.error("ERROR:", error);
      showAlert("Failed to upload preset icon",
        [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
      );
    }
    finally
    {
      stopHudRotation();
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedCollectionName = collectionName.trim();
    const trimmedSubGroupName = subGroupCollectionName.trim();

    if (type === "SubGroup") {

      const errorMsg = validateCollectionName(trimmedSubGroupName);
      
      if (errorMsg) {
        setSubGroupCollectionError(true);
        setSubGroupCollectionErrorMsg(errorMsg);
        return;
      } else {
        setSubGroupCollectionError(false);
        setSubGroupCollectionErrorMsg("");
      }

      const noSubGroupChanges =
        trimmedSubGroupName === initialData.collectionName?.trim() &&
        subGroupDisplay === initialData.display &&
        subGroupCollapsed === initialData.collapsed;

      if (isEditModeOn && noSubGroupChanges) {
        showAlert(
          "No changes are identified",
          [
            {
              label: "Ok",
              color: "var(--buttonColor)",
              onClick: () => { }
            }
          ]
        );
        return;
      }

      const subGroupData = {
        subGroupCollectionName: subGroupCollectionName.trim(),
        subGroupDisplay,
        subGroupCollapsed
      };
      getJsonFromModal(subGroupData);
      console.log('subGroupData', subGroupData)
      return;
    }

    let finalData = [];

    if (activeTab === "list") {

      const errorMsg = validateCollectionName(trimmedCollectionName);

      if (errorMsg) {
        setCollectionError(true);
        setCollectionErrorMsg(errorMsg);
        return;
      } else {
        setCollectionError(false);
        setCollectionErrorMsg("");
      }

      const cleanedListData = listData.map(({ _isNew, ...rest }) => rest);

      const noItemChanges =
            trimmedCollectionName === initialData.collectionName?.trim() &&
            collapsed === initialData.collapsed &&
            display === initialData.display &&
            JSON.stringify(cleanedListData) ===
              JSON.stringify(initialData.items || []);
      
      const noPresetChanges =
            trimmedCollectionName === initialData.collectionName?.trim() &&
            JSON.stringify(cleanedListData) ===
            JSON.stringify(initialData.presets || []);

      if(isEditModeOn && ((type === "Item" &&  noItemChanges) || (type === "Preset" && noPresetChanges)))
      {
        showAlert(
          "No changes are identified",
          [
            {
              label: "Ok",
              color: "var(--buttonColor)",
              onClick: () => {}
            }
          ]
        );
        return;
      }
    
      for (let i = 0; i < listData.length; i++) {
        const row = listData[i];
        if (type === "Item") {
          if (!row.code || !row.code.trim()) {
            showAlert("Code is required",
              [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
            );
            return;
          }
        }
  
        if (type === "Preset") {
          if (!row.preset_id || !row.preset_id.trim()) {
            showAlert("Preset Id is required",
              [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
            );
            return;
          }
        }
  
        if (!row.display_text || !row.display_text.trim()) {
          showAlert("Display Text is required",
            [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
          );
          return;
        }
      }

      const hasUnuploadedIcons = listData.some(
        (row) => row.icon && typeof row.icon !== "string"
      );

      if (hasUnuploadedIcons) {
        showAlert("Please save all uploaded icons before submitting.",
          [{ label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }]
        );
        return;
      }

      syncListToJson(listData);

      if (listData && listData.length > 0) {
        finalData = listData.map(({ _isNew, ...rest }) => rest);
      }
    } 
    
    else if (activeTab === "json") {

      const errorMsg = validateCollectionName(trimmedCollectionName);

      if (errorMsg) {
        setCollectionError(true);
        setCollectionErrorMsg(errorMsg);
        return;
      } else {
        setCollectionError(false);
        setCollectionErrorMsg("");
      }

      if (!jsonData || !jsonData.trim()) {
        setJsonError(`Please add at least one ${type}`);
        showToast({ message: `Please add at least one ${type}` });
        return;
      }

      try {
        const parsed = JSON.parse(jsonData);
        finalData = Array.isArray(parsed) ? parsed : [parsed];

        const noItemChanges =
          trimmedCollectionName === initialData.collectionName?.trim() &&
          collapsed === initialData.collapsed &&
          display === initialData.display &&
          JSON.stringify(finalData) ===
            JSON.stringify(initialData.items || []);

        const noPresetChanges =
          trimmedCollectionName === initialData.collectionName?.trim() &&
          JSON.stringify(finalData) ===
            JSON.stringify(initialData.presets || []);

        if (isEditModeOn && ((type === "Item" && noItemChanges) || (type === "Preset" && noPresetChanges))) {
          showAlert(
            "No changes are identified",
            [
              {
                label: "Ok",
                color: "var(--buttonColor)",
                onClick: () => { }
              }
            ]
          );
          return;
        }

        for (let i = 0; i < finalData.length; i++) {
          const row = finalData[i];

          const hasUnuploadedIcons = listData.some(
            (row) => row.icon && typeof row.icon !== "string"
          );

          if (hasUnuploadedIcons) {
            showAlert("Please save all uploaded icons before submitting.",
              [{ label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }]
            );
            return;
          }
  
          if (type === "Item") {
            if (!row.code || !row.code.trim()) {
              showAlert("Code is required",
                [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
              );
              return;
            }
          }
  
          if (type === "Preset") {
            if (!row.preset_id || !row.preset_id.trim()) {
              showAlert("Preset Id is required",
                [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
              );
              return;
            }
          }
  
          if (!row.display_text || !row.display_text.trim()) {
            showAlert("Display Text is required",
              [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
            );
            return;
          }
        }
      } catch {
        setJsonError("Invalid JSON format");
        return;
      }
    }

    if (finalData.length === 0) {
      setJsonError(`Please add at least one ${type}`);
      showToast({ message: `Please add at least one ${type}` });

      return;
    }

    const itemData = {
      collectionName: collectionName.trim(),
      collapsed,
      display,
      items: finalData,
      subIndex: existingObject?.subIndex,
      itemIndex: existingObject?.itemIndex,
      itemListIndex: existingObject?.itemListIndex
    };

    console.log("Submitting Item Data:", itemData);

    getJsonFromModal(itemData);

  };


  const handleDeleteRow = (index) => {
    showAlert(
      "Are you sure you want to delete this item?",
      [

        {
          label: "No",
          color: "#999",
          onClick: () => { },
        },
        {
          label: "Yes",
          color: "var(--buttonColor)",
          onClick: () => {
            const updated = listData.filter((_, i) => i !== index);
            setListData(updated);
            syncListToJson(updated);
            setIsDirty(true);
          },
        }
      ]
    );
  };


  const normalizeIconForJson = (icon) => {
    if (icon === null || icon === undefined) return "";

    if (typeof icon === "string") {
      return icon;
    }
    if (typeof icon === "object") {
      return {
        fileName: icon.fileName || "",
        base64: icon.base64 || ""
      };
    }

    return "";
  };

  const syncListToJson = (data) => {
    const safeData = data || [];

    let existingJson = [];
    try {
      existingJson = JSON.parse(jsonData || "[]");
    } catch {
      existingJson = [];
    }

    if (type === "Preset") {
      const cleaned = safeData.map((row, index) => ({
        ...(existingJson[index] || {}),
        preset_id: row.preset_id || "",
        display_text: row.display_text || "",
        icon: normalizeIconForJson(row.icon)
      }));
      setJsonData(JSON.stringify(cleaned, null, 2));
    }

    if (type === "Item") {
      const cleaned = safeData.map((row, index) => ({
        ...(existingJson[index] || {}),
        code: row.code || "",
        display_text: row.display_text || "",
        icon: normalizeIconForJson(row.icon),
        display: row.display || "hide",
        long_description: row.long_description || "",
        short_description: row.short_description || "",
        log_text:row.log_text || "",
        preset_ids: row.preset_ids || []
      }));
      setJsonData(JSON.stringify(cleaned, null, 2));
    }
  };


  const syncJsonToList = () => {
    if (!jsonData || jsonData.trim() === "") {
      setListData([]);
      return;
    }

    try {
      const parsed = JSON.parse(jsonData);

      if (!Array.isArray(parsed)) {
        showToast({ message: "JSON must be an array" });
        return;
      }

      if (type === "Preset") {
        setListData(
          parsed.map(item => ({
            ...item,
            preset_id: item.preset_id || "",
            display_text: item.display_text || "",
            icon: item.icon ?? "",
            _isNew: false
          }))
        );
      }

      if (type === "Item") {
        setListData(
          parsed.map(item => ({
            ...item,
            code: item.code || "",
            display_text: item.display_text || "",
            icon: item.icon ?? "",
            display: item.display || "hide",
            long_description: item.long_description || "",
            short_description: item.short_description || "",
            log_text:item.log_text || "",
            preset_ids: Array.isArray(item.preset_ids) ? item.preset_ids : [],
            _isNew: false
          }))
        );
      }
    } catch (err) {
      showToast({ message: "Invalid JSON format" });
    }
  };


  const convertFileToBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1]; // remove the data: prefix
      callback(base64Data);
    };
    reader.readAsDataURL(file);
  };

  const handleClose = () => {
    if (isDirty) {
      showAlert(
        "You have unsaved changes. Are you sure you want to leave ?",
        [
          {
            label: "Cancel",
            onClick: () => { },
            color: "#999",
          },
          {
            label: "Leave",
            onClick: () => {
              setIsDirty(false);
              onClose();
            },
            color: "var(--buttonColor)",
          },
        ]
      );
    }
    else {
      onClose();
    }
  }

  return (
    <div className='addUserModal-item'>
      <div className={`addUserBody-item ${type === "SubGroup" ? "subgroup-modal" : ""}`}>

        {/* HEADER */}
        <div className='addUserHeader-item'>
          <span>
            {isEditModeOn ? (
              <>
                Edit {type || ''}{" "}
                {existingObject?.subGroupName && (
                  <span className="subgroup-name">{`in ${existingObject.subGroupName}`}</span>
                )}
              </>
            ) : (
              <>
                Add {type || ''}{" "}
                {existingObject?.subGroupName && (
                  <span className="subgroup-name">{`in ${existingObject.subGroupName}`}</span>
                )}
              </>
            )}
          </span>
          <MdCancel size={24} className='closeAddForm' onClick={handleClose} />
        </div>



        {/* BODY */}
        <div className='addUserBodyMain-item'>
          <form onSubmit={handleSubmit} style={{ padding: "8px" }}>


            {type === 'SubGroup' && (

              <div className="subgroup-section">

                <div className="collection-name">
                  <label>Collection Name</label>

                  <div className="input-collection">
                    <input
                      type="text"
                      value={subGroupCollectionName}
                      onChange={handleSubGroupChange}
                      maxLength={100}
                      className={`form-control addInputUser ${
                        subGroupCollectionError ? "input-error" : ""
                      }`}                      
                      placeholder="Collection Name"
                    />

                  {subGroupCollectionError && (
                    <div className="error-text">
                      {subGroupCollectionErrorMsg}
                    </div>
                  )}
                  </div>
                </div>


                <div className="radio-group-itemPre">
                  <div className="collapse-field">
                    <label className="collapse-label">Collapsed</label>
                    <div className="radio-group-label">
                      <div className="radio-fields">
                        <input type="radio" name="subGroupCollapsed" checked={subGroupCollapsed === true}
                          onChange={() => { setSubGroupCollapsed(true); setIsDirty(true); }} />
                        <span>True</span>
                      </div>
                      <div className="radio-fields">
                        <input type="radio" name="subGroupCollapsed" checked={subGroupCollapsed === false}
                          onChange={() => { setSubGroupCollapsed(false); setIsDirty(true); }} />
                        <span>False</span>
                      </div>
                    </div>
                  </div>

                  {/* SubGroup Display */}
                  <div className="toggle-display">
                    <label>Display</label>
                    <div className="form-switch toggelinput mb-0" style={{ flex: 1 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={subGroupDisplay === 'show'}
                        onChange={(e) => { setSubGroupDisplay(e.target.checked ? 'show' : 'hide'); setIsDirty(true); }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* COLLECTION NAME + LABEL SIDE BY SIDE */}

            {(type === 'Item' || type === 'Preset') && (
              <div className="collection-name"  >

                <label style={{ fontWeight: 500, fontSize: '14px' }}>
                  Collection Name
                </label>

                <div className="input-collection">

                <input type="text" name="collectionName" value={collectionName}  maxLength={100}
                  onChange={handleCollectionNameChange} 
                  className={`form-control addInputUser ${
                    CollectionError ? "input-error" : ""
                  }`}   
                  placeholder="Collection Name"
                />

                  {CollectionError && (
                    <div className="error-text">
                      {CollectionErrorMsg}
                    </div>
                  )}
                </div>
              </div>
            )}


            {/* RADIO BUTTONS */}

            <div className="radio-group-itemPre ">

              {(type === "Item") && (
                <div className="collapse-field">
                  <label className="collapse-label">Collapsed </label>
                  <div className="radio-group-label">
                    <div className="radio-fields">
                      <input
                        type="radio"
                        name="collapsed"
                        checked={collapsed === true}
                        onChange={() => { setCollapsed(true); setIsDirty(true) }}
                      />
                      <span>True</span>
                    </div>

                    <div className="radio-fields">
                      <input
                        type="radio"
                        name="collapsed"
                        checked={collapsed === false}
                        onChange={() => { setCollapsed(false); setIsDirty(true) }}
                      />
                      <span>False</span>
                    </div>
                  </div>
                </div>

              )}

              {(type === "Item") && (

                <div className="toggle-display">
                  <label> Display </label>
                  <div className="form-switch toggelinput mb-0" style={{ flex: 1 }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="displaySwitch"
                      checked={display === "show"}
                      onChange={(e) => {
                        setDisplay(e.target.checked ? "show" : "hide");
                        setIsDirty(true);
                      }}
                    />
                  </div>
                </div>
              )}

              {(type === "Item" || type === "Preset") && (
                <div className="tab-container">
                  <button
                    type="button"
                    className={`tab-pill ${activeTab === "json" ? "active" : ""}`}
                    style={{
                      pointerEvents: activeTab === "json" ? "none" : "auto",
                    }}
                    onClick={() => {
                      syncListToJson(listData);
                      setActiveTab("json");
                    }}
                  >
                    JSON
                  </button>

                  <button
                    type="button"
                    className={`tab-pill ${activeTab === "list" ? "active" : ""}`}
                    style={{
                      pointerEvents: activeTab === "list" ? "none" : "auto",
                    }}
                    onClick={() => {
                      syncJsonToList();
                      setActiveTab("list");
                    }}
                  >
                    LIST
                  </button>
                </div>
              )}
            </div>


            {/* JSON TEXTAREA */}
            {type !== "SubGroup" && activeTab === "json" && (

              <div style={{ marginTop: "20px" }}>

                <textarea
                  className={`w-full form-control p-2 border rounded font-mono text-sm 
                  ${jsonError ? "border-red-500" : "border-gray-300"}`}
                  placeholder='{"key": "value"}'
                  value={jsonData}
                  onChange={(e) => {
                    const text = e.target.value;
                    setJsonData(text);
                    setIsDirty(true);

                    try {
                      JSON.parse(text);
                      setJsonError("");
                    } catch {
                      setJsonError("Invalid JSON format");
                    }
                  }}
                  style={{
                    width: "100%",
                    minHeight: "350px",
                    height: "calc(100vh - 480px)",
                    overflowY: "scroll",
                    resize: "none"
                  }}
                />

                {jsonError && (
                  <p className="text-red-500 text-sm mt-1" style={{ color: 'red', marginLeft: '3px' }}>{jsonError}</p>
                )}
              </div>
            )}

            {type === "Item" && activeTab === "list" && (
              <div style={{ marginTop: "5px" }} >

                <div className="list-header-row">
                  <span
                    className="add-item-btn"
                    onClick={handleAddItem}

                  >
                    Add Item
                  </span>
                </div>
                <div className="table-item-container">
                  <table className="list-table">
                    <colgroup>
                      <col style={{ width: "10%" }} />   {/* Code */}
                      <col style={{ width: "18%" }} />  {/* Display Text */}
                      <col style={{ width: "6%" }} />   {/* Icon */}
                      <col style={{ width: "20%" }} />  {/* Long Description */}
                      <col style={{ width: "18%" }} />  {/* Short Description */}
                      <col style={{ width: "15%" }} />  {/* Log Text */}
                      <col style={{ width: "5%" }} />   {/* Display */}
                      <col style={{ width: "8%" }} />   {/* Preset Ids */}
                      <col style={{ width: "6%" }} />   {/* Action */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Display Text</th>
                        <th>Icon</th>
                        <th>Long Description</th>
                        <th>Short Description</th>
                        <th>Log Text</th>
                        <th>Display</th>
                        <th>Preset Ids</th>
                        <th>Action</th>

                      </tr>
                    </thead>

                    <tbody>
                      {listData.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter code"
                              value={row.code || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].code = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>

                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter display text"

                              value={row.display_text || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].display_text = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>

                          <td>
                            <div className="icon-upload-wrapper">
                              

                                  <input
                                    type="file"
                                    accept=".png,.jpg,.jpeg,.svg"
                                    hidden
                                    ref={(el) => (fileInputRefs.current[index] = el)}
                                    onChange={(e) =>
                                      handleItemIconUpload(index, e.target.files[0])
                                    }
                                  />

                                  <span className="upload-btn"
                                   onClick={() => fileInputRefs.current[index].click()}>
                                    Upload
                                  </span>

                                  <span className="file-name">
                                    {typeof row.icon === "string"
                                      ? row.icon.split("/").pop()
                                      : row.icon?.fileName || "No file"}
                                  </span>

                                  {row.icon &&
                                    (typeof row.icon === "string"
                                      ? row.icon.trim().length > 0
                                      : row.icon?.fileName) && (
                                      <button
                                        className="btn-clear"
                                        type="button"
                                        onClick={() => handleClearIcon(index)}
                                      >
                                        Clear
                                      </button>
                                    )}

                                  <button className="btn-save-small" type="button"
                                    onClick={() => handleItemSave(index)} >
                                    Save
                                  </button>
                            

                            </div>
                          </td>
                          
                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter long description"
                              value={row.long_description || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].long_description = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter short description"
                              value={row.short_description || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].short_description = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>

                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter log text"
                              value={row.log_text || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].log_text = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>

                          <td>
                            <div className="form-switch toggelinputItem mb-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={row.display === "show"}
                                onChange={(e) => {
                                  const updated = [...listData];
                                  updated[index].display = e.target.checked ? "show" : "hide";
                                  setListData(updated);
                                  setIsDirty(true);
                                }}
                              />
                            </div>
                          </td>

                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter presets"
                              value={(row.preset_ids || []).join(",")}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].preset_ids = e.target.value
                                  .split(",")
                                  .map(v => v.trim());
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>
                          <td>
                            <RiDeleteBin3Fill style={{ color: "#dc3545", marginLeft: "7px", cursor: "pointer" }} size="16px"
                              onClick={() => { handleDeleteRow(index); setIsDirty(true); }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            {type === "Preset" && activeTab === "list" && (
              <div style={{ marginTop: "5px" }}>
                <div className="list-header-row">
                  <span
                    className="add-item-btn"
                    onClick={handleAddPreset}
                  >
                     Add Preset
                  </span>
                </div>
                <div className="table-item-container">

                  <table className="list-table">
                    <thead>
                      <tr>
                        <th>Preset Id</th>
                        <th>Display Text</th>
                        <th>Icon</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {listData.map((row, index) => (
                        <tr key={index}>

                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter preset id"

                              value={(row.preset_id)}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].preset_id = e.target.value
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control list-input"
                              placeholder="Enter display text"

                              value={row.display_text || ""}
                              onChange={(e) => {
                                const updated = [...listData];
                                updated[index].display_text = e.target.value;
                                setListData(updated);
                                setIsDirty(true);

                              }}
                            />
                          </td>


                          <td>
                            <div className="icon-upload-wrapper">

                              
                                <input
                                  type="file"
                                  accept=".png,.jpg,.jpeg,.svg"
                                  hidden
                                  ref={(el) => (fileInputRefs.current[index] = el)}
                                  onChange={(e) =>
                                    handleIconUpload(index, e.target.files[0])
                                  }
                                />
                                <span className="upload-btn"
                                   onClick={() => fileInputRefs.current[index].click()}>
                                  Upload
                                </span>

                                <span className="file-name">
                                  {typeof row.icon === "string"
                                    ? row.icon.split("/").pop()
                                    : row.icon?.fileName || "No file"}
                                </span>

                              {row.icon &&
                                (typeof row.icon === "string"
                                  ? row.icon.trim().length > 0
                                  : row.icon?.fileName) && (
                                  <button
                                    className="btn-clear"
                                    type="button"
                                    onClick={() => handleClearIcon(index)}
                                  >
                                    Clear
                                  </button>
                                )}


                                <button className="btn-save-small" type="button"
                                  onClick={() => handlePresetSave(index)}>
                                  Save
                                </button>
                            </div>

                          </td>

                          <td>
                            <RiDeleteBin3Fill
                              style={{ color: "#dc3545", cursor: "pointer" }} size="16px"
                              onClick={() => handleDeleteRow(index)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>
            )}

            {/* BUTTON */}
            <div className="button-right-modal" >
              <button type="submit" className="add-button-modal">
                {isEditModeOn ? "Update" : "Save"}
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  );
};

export default ItemsAndPresetObjectsModal;
